import React from "react";
import Hero from "../components/Hero";

export default function ServicesPage() {
  return (
    <div className="bg-[#1A1F2B] text-white w-full min-h-screen flex flex-col items-center">

      {/* Section 1: Hero */}
      {/* <section className="w-full bg-[#1A1F2B] px-4 md:px-6 py-16 text-center mt-8" data-aos="fade-up">
        <h1 className="text-3xl md:text-5xl font-bold mb-4 text-[#D9A05B]">
          Our Services
        </h1>
        <p className="text-base md:text-xl max-w-3xl mx-auto text-[#F5E9D8] leading-relaxed">
          At Moriah Church, our services are designed to nurture spiritual
          growth, deepen faith, and help believers walk closely with Jesus
          Christ through worship, teaching, prayer, and community care.
        </p>
      </section> */}
      <Hero title="Our Services" description="At Moriah Church, our services are designed to nurture spiritual
          growth, deepen faith, and help believers walk closely with Jesus
          Christ through worship, teaching, prayer, and community care."/>

      {/* Section 2: Prayer & Worship */}
      <section className="w-full bg-[#F5E9D8] text-[#1A1F2B] px-4 md:px-6 py-14 rounded-t-3xl">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-6 md:gap-10">

          <div className="flex-1" data-aos="fade-right">
            <h2 className="text-2xl md:text-3xl font-bold text-center md:text-left mb-4">
              Prayer & Worship Gatherings
            </h2>
            <p className="text-base md:text-lg leading-relaxed mb-4">
              Worship is the heart of Moriah Church. Throughout the week,
              believers gather to pray, study God’s Word, and grow together
              in faith.
            </p>

            <ul className="text-base md:text-lg space-y-2 list-disc ml-5">
              <li><strong>Intercessory Prayer:</strong> Daily • 5:00 AM – 6:00 AM</li>
              <li><strong>Bible Study:</strong> Thursday • 7:00 PM – 8:00 PM</li>
              <li><strong>Fasting Prayer:</strong> Friday • 11:00 AM – 1:00 PM</li>
              <li><strong>Friday Night Prayer:</strong> 10:00 PM – 12:00 AM</li>
              <li><strong>Saturday Preparation Prayer:</strong> 7:00 PM – 8:00 PM</li>
              <li><strong>Sunday School:</strong> 9:00 AM – 10:00 AM</li>
              <li><strong>Sunday Worship Service:</strong> 10:00 AM – 12:30 PM</li>
            </ul>
          </div>

          <div className="flex-1" data-aos="fade-left">
            <img
              src="/Images/memo1.jpg"
              alt="Prayer"
              className="w-full h-64 md:h-full object-cover rounded-lg"
            />
          </div>

        </div>
      </section>

      {/* Section 3: Discipleship */}
      <section className="w-full bg-[#1A1F2B] px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-6 md:gap-10">

          <div className="flex-1" data-aos="fade-right">
            <h2 className="text-2xl md:text-3xl font-bold text-center md:text-left text-[#D9A05B] mb-4">
              Discipleship & Leadership Development
            </h2>
            <p className="text-base md:text-lg leading-relaxed text-[#F5E9D8]">
              Moriah Church is committed to developing mature disciples and
              godly leaders through teaching, mentoring, and hands-on ministry.
            </p>
          </div>

          <div className="flex-1" data-aos="fade-left">
            <img
              src="/Images/memo1.jpg"
              alt="Discipleship"
              className="w-full h-64 md:h-full object-cover rounded-lg"
            />
          </div>

        </div>
      </section>

      {/* Section 4: Women & Youth */}
      <section className="w-full bg-[#D2CBC3] text-[#1A1F2B] px-4 md:px-6 py-14 rounded-t-3xl">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-6 md:gap-10">

          <div className="flex-1" data-aos="fade-right">
            <h2 className="text-2xl md:text-3xl font-bold text-center md:text-left mb-4">
              Women & Youth Empowerment
            </h2>
            <p className="text-base md:text-lg leading-relaxed mb-4">
              At Moriah Church, women and young people are encouraged to grow
              spiritually and develop leadership skills.
            </p>

            <ul className="list-disc ml-5 text-base md:text-lg space-y-2">
              <li>Women’s fellowship and counseling</li>
              <li>Youth worship team and ministry activities</li>
              <li>Training in music, media, and leadership</li>
              <li>Bible-based mentoring</li>
            </ul>
          </div>

          <div className="flex-1" data-aos="fade-left">
            <img
              src="\Images\youth-main.jpeg" 
              alt="Youth Empowerment"
              className="w-full h-64 md:h-full object-cover rounded-lg"
            />
          </div>

        </div>
      </section>

      {/* Section 5: Community Outreach */}
      <section className="w-full bg-[#F5E9D8] text-[#1A1F2B] px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-6 md:gap-10">

          <div className="flex-1" data-aos="fade-right">
            <h2 className="text-2xl md:text-3xl font-bold mb-4">
              Community Care & Social Impact
            </h2>
            <p className="text-base md:text-lg leading-relaxed mb-4">
              We actively serve the poor, the needy, and the destitute with
              compassion and care.
            </p>
            <p className="text-base md:text-lg leading-relaxed">
              Through outreach and counseling, we bring hope and healing
              to individuals and families.
            </p>
          </div>

          <div className="flex-1" data-aos="fade-left">
            <img
              src="/Images/memo1.jpg"
              alt="Community Outreach"
              className="w-full h-64 md:h-full object-cover rounded-lg"
            />
          </div>

        </div>
      </section>

    </div>
  );
}
